<template>
    <ChartBlock :data="data" v-if="isLoading" />
    <LoadingWrap v-else />
</template>


<script>
import { getDartData } from '@/api';
import ChartBlock from '@/components/ChartBlock.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';


export default {
    components: {
        ChartBlock,
        LoadingWrap
    },
    data() {
        return {
            isLoading: false,
            data: {
                unit: '천원',
                stacked: true,
                step: 150000000,
                type: [
                    {
                        name: '현금증감',
                        type: 'line',
                        color: '#5f48c4',
                        data: [],
                    },
                    {
                        name: '기말현금',
                        type: 'line',
                        color: '#48c4c0',
                        data: [],
                    },
                    {
                        name: '기초현금',
                        type: 'bar',
                        color: '#2f7ed8',
                        data: [],
                    },
                    {
                        name: '영업활동',
                        type: 'bar',
                        color: '#f9cd5b',
                        data: [],
                    },
                    {
                        name: '투자활동',
                        type: 'bar',
                        color: '#f56e4d',
                        data: [],
                    },
                    {
                        name: '재무활동',
                        type: 'bar',
                        color: '#42c294',
                        data: [],
                    },
                ],
                years: [],
            },
        };
    },
    async mounted() {
        const {
            data: { CF },
        } = await getDartData();
        const modifyData = Object.keys(CF).reduce(
            (acc, key) => {
                Object.entries(CF[key]).forEach((entrie) => {
                    if (!acc.years.includes(entrie[0])) acc.years.push(entrie[0]);
                    if (!acc.type[key]) {
                        acc.type[key] = [entrie[1]];
                    } else {
                        acc.type[key].push(entrie[1]);
                    }
                });
                return acc;
            },
            {
                type: {},
                years: [],
            }
        );

        this.data.type[0].data = modifyData.type.increaseDecreaseInCashAndCashEquivalents; //현금증감
        this.data.type[1].data = modifyData.type.cashAndCashEquivalentsAtEndOfPeriodCf; //기말현금
        this.data.type[2].data = modifyData.type.cashAndCashEquivalentsAtBeginningOfPeriodCf; //기초현금
        this.data.type[3].data = modifyData.type.cashFlowsFromUsedInOperatingActivities; //영업활동
        this.data.type[4].data = modifyData.type.cashFlowsFromUsedInInvestingActivities; //투자활동
        this.data.type[5].data = modifyData.type.cashFlowsFromUsedInFinancingActivities; //재무활동
        this.data.years = modifyData.years;

        this.isLoading = true;
    },
};
</script>

<style></style>
